import { formatDistance } from 'date-fns';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useNotifications } from 'global/cnr/contexts/useHelpers/useNotifications';
import _ from 'lodash';
import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { Icon, Segment } from 'semantic-ui-react';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { appNotificationsViewerHandlers, appNotificationsViewerInitialState, appNotificationsViewerReducer, viewModes } from '../cnr/reducers/AppNotificationViewerReducer';
import { formatItem, formatTypes } from '../common/dateFormatting';
import { uniqueKey } from '../common/keys';
import NoData from '../components/alerts/NoData';
import UiSaveButtons from '../components/buttons/UiSaveButtons';
import DropdownOptionsMenu from '../components/forms/elements/DropdownOptionsMenu';
import { gEnums } from '../enums/globalEnums';
import { iconColorTypes } from '../enums/settingsIconTypes';
import UiHeader from '../pageItem/UiHeader';
import { openExternal } from '../viewSettings/helpers/settingsLinks';
import FullPageWrapper from '../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper';
import CreateNotificationWizard from './CreateNotificationWizard';
import CreateTopicWizard from './CreateTopicWizard';
import NotificationItemStatusWithProvider from './NotificationItemStatus';
import NotificationList from './NotificationList';
import { useFcm } from 'global/cnr/contexts/useHelpers/useFcm';
import { buildFcmPayload } from 'global/functions/fbNotifications';

const _noteBodyMax = 32

export const AppNotificationsViewerContext = createContext();

export const appNotificationTypes = {
  settings: 'settings',
  notifications: 'notifications',
  userNotifications: 'userNotifications',
  notificationsManager: 'notificationsManager',
}

const AppNotificationsManager = (props) => {

  const { forSettings, appNotificationType, useDarkMode } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers, fns, fn_cls } = parentContext ?? {}
  const { baseSettings_state, appForms_state, appNotifications_state, googleSheets_state, currentSettings_state, page_state, paps_state, eventInfo_state } = states

  const { appNotifications_handlers, navigate } = handlers

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const { pathViews } = paps_state
  const { database_fns, page_fns } = fns

  const { aps_appUserSettings, aps_styles } = _.get(currentSettings_state, 'gvviSettings', {});
  const { otherView } = _.get(page_state, 'pageSettings', {});

  const { staticViews } = eventInfo_state ?? {}

  console.log('database_fns', database_fns)

  // notifications
  const { notifications_app, notifications_appUser } = appNotifications_state

  // googleSheetsContext 
  const { googleSheetsData } = googleSheets_state ?? {}
  const { notifications: notifications_google } = googleSheetsData ?? {}
  const _notifications = notifications_google ? notifications_google : notifications_app

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frameworkRightType, frameworkLeftType } = framework_state ?? {}
  const inFramework = frameworkRightType || frameworkLeftType

  // appNotificationsViewer
  const initState = appNotificationsViewerInitialState({ pathViews, database_fns, page_fns, staticViews, aps_appUserSettings })
  const [appNotificationsViewer_state, dispatch] = useReducer(appNotificationsViewerReducer, initState);
  const appNotificationsViewer_handlers = appNotificationsViewerHandlers(dispatch)

  const use_notes = useNotifications()
  const { sendFcm_payload, fcmResponse } = useFcm()

  const { viewMode, activeNotificationKey, timedNotificationGroupsKeys, timedNotificationGroups } = appNotificationsViewer_state ?? {}
  const { handleInit_notifications, handleSetViewMode } = appNotificationsViewer_handlers ?? {}

  const [currentNotification, setCurrentNotification] = useState()

  const styleAndClass = aps_styles?.[gEnums?.projectStyles?.actionButton] ?? { style: {} };
  styleAndClass.className += ' single'

  const handleUserNotificationClick = (sn) => {
    appNotifications_handlers.handleMarkAsSeen(sn)
    if (currentNotification && currentNotification._itemKey === sn._itemKey) {
      setCurrentNotification()
    } else {
      setCurrentNotification(sn)
    }
  }

  const handleOpenDb = () => openExternal.db(pathViews, false, ['_notifications'])
  const handleCancel = () => props.handleCancel ? props.handleCancel() : navigate(-1)

  useEffect(() => {
    handleInit_notifications(_notifications)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_notifications]);

  useEffect(() => {
    switch (appNotificationType) {
      case appNotificationTypes.userNotifications:
        handleSetViewMode(viewModes.user)
        break;
      case appNotificationTypes.notifications:
        handleSetViewMode(viewModes.list)
        break;
      case appNotificationTypes.notificationsManager:
        handleSetViewMode(viewModes.normal)
        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShowNormal = () => handleSetViewMode(viewModes.normal)
  const handleShowEdit = () => handleSetViewMode(viewModes.edit)
  const handleTest = () => fn_cls.checkNotification_direct(true)
  const handleTriggerSchedule = () => fn_cls.checkNotification_direct()
  const handleRemove = () => {
    console.log('zzz', use_notes.removeNotification)
    // appNotifications_handlers.handleRemoveNotification(activeNotificationKey, handleShowNormal)}
  }

  const handleUpdateActive = () => {
    const cb = (res) => { console.log('handleUpdateActive', true) }
    const n = _notifications[activeNotificationKey]
    n.active = !n.active
    console.log('n', n)
    use_notes.updateNotifications(n, n, cb)
  }

  const handleUpdateSend = () => {
    const cb = (res) => { console.log('handleUpdateSend', true) }
    const n = _notifications[activeNotificationKey]
    n.sent = !n.sent
    use_notes.updateNotifications(n, n, cb)
  }

  const handleSendFcm = () => {
    const { fcmTokens } = appUserAccess ?? {}
    const _tokens = _.map(fcmTokens, item => item.tokenKey);
    const n = _notifications[activeNotificationKey]
    const fcmPayload = buildFcmPayload(_tokens, null, n.title, n.body)
    sendFcm_payload(fcmPayload)
  }

  const handleAddNormalClick = () => {
    if (otherView === 'add') {
      navigate(-1)
    } else {
      handleSetViewMode(viewMode === viewModes.addNormal ? viewModes.normal : viewModes.addNormal)
    }
  }

  const handleAddNormalDirect = () => {
    if (otherView === 'add') {
      navigate(-1)
    } else {
      handleSetViewMode(viewMode === viewModes.addDirect ? viewModes.normal : viewModes.addDirect)
    }
  }

  const header = () => {
    if (inFramework) {
      return <UiHeader caption={'Notifications Manager'} />
    } else {
      const icon1 = { handleOnClick: handleAddNormalClick }
      const icon2 = { handleOnClick: handleAddNormalDirect, icon: 'calendar outline' }
      return <UiHeader caption={'Notifications List'} icons={[icon1, icon2]} />
    }
  }

  const header_item = () => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>Notification Item</div>
    <div><Icon name='delete' onClick={(e) => handleSetViewMode(viewModes.normal)} /></div>
  </div>

  const buttons = (note) => {
    const { active, sent } = note ?? {}
    const btns = [
      { caption: active ? 'Active' : 'Activate', icon: active ? 'check' : 'arrow right', oc: handleUpdateActive, color: active ? 'green' : 'grey' },
      { caption: sent ? 'Sent' : 'Send', icon: sent ? 'check' : 'arrow right', oc: handleUpdateSend, color: sent ? 'green' : 'grey' },
      { caption: 'Send as FCM', icon: 'arrow right', oc: handleSendFcm, color: 'blue' },
      { caption: 'Edit', icon: 'edit', oc: handleShowEdit, color: 'blue', fl: true },
    ]
    return <UiSaveButtons
      clickOptions={note}
      others={btns}
    />
  }

  const wrapper_confirmation = (note) => <Wrapper
    key={uniqueKey('apn', 'cw')}
    header={header_item()}
    content={<NotificationItemStatusWithProvider notification={note} />}
    footer={buttons(note)}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_preview = (note) => {
    if (forSettings) {
      return wrapper_confirmation(note)
    } else {
      <FullPageWrapper
        topperCaption={'Notification' + _.startCase(viewMode)}
        topperCaption2={activeNotificationKey}
        content={wrapper_confirmation(note)}
        handleCancel={handleShowNormal}
        isBack={true}
      />
    }
  }

  const deleteWrapper = () => <Wrapper
    key={uniqueKey('apn', 'dw')}
    header={'Comfirm'}
    content={'Are you sure you want to delete this item?'}
    footer={
      <UiSaveButtons
        delete={{ oc: handleShowNormal, caption: 'Close' }}
        save={{ oc: handleRemove, caption: 'Confirm' }}
      />
    }
    wrapperType={wrapperTypes.padded}
  />

  /**
   * 
   * @param {string} type 
   * @param {object} notifications_date 
   * @returns the NotificationList
   */
  const notificationList = (type, notifications_date) => <NotificationList
    type={type}
    notifications_date={notifications_date}
  />

  const dateGroup = (ngk) => {
    if (timedNotificationGroups && timedNotificationGroups[ngk]) {
      const ng = timedNotificationGroups[ngk]
      return notificationList(gEnums.notificationScheduleTypes.scheduled, ng)
    }
  }

  const notificationDateGroups = (type) => {
    const groups = []
    timedNotificationGroupsKeys.forEach((ngk, index) => {
      groups.push(<div key={uniqueKey('apn', 'dg', index)} className={'app-notification-date-group'}>
        <div key={uniqueKey('apn', 'f', index)} >{formatItem(formatTypes.shortDate, ngk)}</div>
        <div key={uniqueKey('apn', 'd', index)} >{dateGroup(ngk)}</div>
      </div>)
    })
    return groups
  }

  const noteItem = (aun, index, full) => {
    const { title, body, read, sendDateUTC } = aun ?? {}
    const yyy = sendDateUTC ? formatDistance(new Date(sendDateUTC), new Date(), { addSuffix: true }) : null
    const _body = full ? body : body.substring(0, _noteBodyMax) + '...'
    return <div style={{ display: 'flex', flexDirection: 'row', padding: '1em', borderBottom: '1px solid var(--off-black-2' }} onClick={(e) => handleUserNotificationClick(aun)}>
      <div>
        <Icon
          name={read ? 'check circle' : 'circle outline'}
          color={read ? 'green' : 'grey'}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1em', marginLeft: '1em' }}>
        <div>
          {title}
        </div>
        <div>
          {_body}
        </div>
      </div>
    </div>
  }

  const noteItems_appUser = () => {
    const ntis = []
    const _notes = notifications_appUser.all
    if (_notes && _notes.length > 0) {
      const _notes_s = _.orderBy(_notes, 'sendDateUTC', 'desc')
      _notes_s.forEach((aun, index) => {
        if (currentNotification) {
          if (currentNotification._itemKey === aun._itemKey) {
            ntis.push(noteItem(aun, index, true))
          }
        } else {
          ntis.push(noteItem(aun, index))
        }
      })
    }
    return ntis
  }

  const notificationsList_appUser = () => <Segment basic>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
      {noteItems_appUser()}
    </div>
  </Segment>

  const notificationSeg = (type, content) => <div className={'app-notification-group'}>
    <div>{content}</div>
  </div>

  const notification_list = () => {
    if (timedNotificationGroupsKeys && timedNotificationGroupsKeys.length > 0) {
      return notificationSeg(gEnums.notificationScheduleTypes.scheduled, notificationDateGroups(gEnums.notificationScheduleTypes.scheduled))
    } else {
      return <NoData altCaption={_.startCase(gEnums.notificationScheduleTypes.scheduled)} />
    }
  }

  const noteButtons = () => {
    const btns = [{ oc: handleAddNormalClick, icon: 'add', caption: 'Add' }]
    const btns_dd = []
    if (isAdminOrSuper) {
      btns_dd.push({ oc: handleOpenDb, icon: 'external alternate', color: iconColorTypes.external, caption: 'Open Database', fl: true })
      btns_dd.push({ oc: handleTest, icon: 'wizard', caption: 'Test', fl: true })
      if (timedNotificationGroupsKeys && timedNotificationGroupsKeys.length > 0) {
        btns_dd.push({ oc: handleTriggerSchedule, icon: 'arrow right', caption: 'Trigger Scheduled', fl: true })
      }
    }

    return <div className={'header-flex'}>
      <div>
        <DropdownOptionsMenu menuButtons={btns_dd} caption={'Options'} icon={'unordered list'} color={'blue'} direction={'right'} upward={true} />
      </div>
      <div>
        <UiSaveButtons
          others={btns}
          color={'blue'}
        />
      </div>
    </div>
  }

  const wrapper = () => <Wrapper
    key={uniqueKey('apn', 'wrap')}
    header={!forSettings || inFramework && header()}
    content={notification_list()}
    footer={noteButtons()}
    wrapperType={wrapperTypes.paddedHeader}
  />

  const fpw_notifications = (content) => {
    if (forSettings) {
      return content
      // return <Segment key={uniqueKey('apn', 'wiz')} className={'app-notification-container anm'} inverted={useDarkMode}>{content}</Segment>
    } else {
      return <FullPageWrapper
        topperCaption={'Notifications'}
        topperCaption2={_.startCase(appNotificationType)}
        content={content}
        handleCancel={handleCancel}
        css={{ container: 'app-dark-mode' }}
      />
    }
  }


  const notificationsContent = () => {
    console.log('viewMode', viewMode)
    switch (viewMode) {
      case viewModes.normal:
        return fpw_notifications(wrapper())
      case viewModes.list:
        return fpw_notifications(!_.isEmpty(notifications_appUser?.all) ? notificationsList_appUser() : <NoData fullCaption={'No Notifications'} />)
      case viewModes.user:
        return !_.isEmpty(notifications_appUser?.all) ? notificationsList_appUser() : <NoData fullCaption={'No Notifications'} />
      case viewModes.preview:
        return fpw_preview(_notifications[activeNotificationKey])
      case viewModes.edit:
        return <CreateNotificationWizard isSub={true} forSettings={forSettings} notificationOriginType={gEnums.notificationOriginTypes.appNotification} handleClose={handleShowNormal} activeNote={_notifications?.[activeNotificationKey]} />
      case viewModes.remove:
        return fpw_notifications(deleteWrapper())
      case viewModes.addDirect:
      case viewModes.addNormal:
        return <CreateNotificationWizard isSub={true} forSettings={forSettings} notificationOriginType={gEnums.notificationOriginTypes.appNotification} activeNote={_notifications?.[activeNotificationKey]} />
      case viewModes.addTopic:
        return <CreateTopicWizard handleCancel={handleShowNormal} topicOriginType={gEnums.topicOriginTypes.global} />
      default:
        return <FullPageWrapper
          topperCaption={'Notifications'}
          topperCaption2={_.startCase(appNotificationType)}
          content={<NoData altCaption={'Notifications'}></NoData>}
          handleCancel={handleCancel}
        />
    }
  }

  return <AppNotificationsViewerContext.Provider value={{ appNotificationsViewer_state, appNotificationsViewer_handlers }}>
    {notificationsContent()}
  </AppNotificationsViewerContext.Provider>

}

export default AppNotificationsManager